var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.$options.i18n.buttonText}},[_c('gl-button',{attrs:{"category":"tertiary","icon":"clock","aria-label":_vm.$options.i18n.buttonText,"disabled":_vm.isPromotionInProgress},on:{"click":_vm.handleButtonClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }